var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"inline-block",attrs:{"to":{ path: _vm.path },"append":""}},[_c('span',{class:_vm.span_class_list,on:{"click":function($event){return _vm.$emit('changeTab', _vm.tab_index)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }